<template>
  <div v-show="false">
    <v-row>
      <v-container>
      <v-col cols="12">
        <v-btn
      elevation="2"
      @click="handleClickLogin"
      color="green"
      >Google Log in</v-btn>
      </v-col>
      <v-col cols="12">
      <!-- <v-row v-if="checkLogin"> -->
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="refreshToken"
                  label="refreshToken"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="eventId"
                  label="eventId"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  elevation="2"
                  color="orange"
                  @click="getEvent()"
                  >Get Event</v-btn>
              </v-col>
              <!-- <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="calendarId"
                  label="calendarId"
                  outlined
                ></v-text-field>
              </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>
        <hr>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="Summmary"
                  label="Summmary"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="Description"
                  label="Description"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="Location"
                  label="Location"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="StartDate"
                      label="StartDate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="StartDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="EndDate"
                      label="EndDate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="EndDate"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-btn
                  elevation="2"
                  color="info"
                  @click="createEvent()"
                  >CREATE Event</v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  elevation="2"
                  color="orange"
                  @click="updateEvent()"
                  >Update Event</v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  elevation="2"
                  color="error"
                  @click="deleteEvent()"
                  >delete Event</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      </v-container>
    </v-row>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment-timezone'
// import QrcodeVue from 'qrcode.vue'
// import adminLeftMenu from '../Sidebar.vue' // เมนู
export default {
  components: {

  },
  data () {
    return {
      eventId: '',
      calendarId: '66h6jueetal14hcm8vn7an38p8@google.com',
      refreshToken: '',
      access_token: '',
      expireDate: '',
      checkLogin: false,
      Summmary: '',
      Description: '',
      Location: '',
      menu1: false,
      menu2: false,
      StartDate: '',
      EndDate: '',
      shopId: '',
      bookingItem: [],
      bookingData: [],
      flowItem: [],
      empItem: [],
      evenStatus: '',
      attendeesEmail: [],
      bookNo: '',
      statusGoogleCalendarEmp: '',
      contactEmail: '',
      webHookUrl: 'https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/'
      // webHookUrl: 'http://127.0.0.1:5004/be-linked-a7cdc/asia-southeast1/'
    }
  },
  async mounted () {
  // await this.checkTypeEvenEmp()
  },
  methods: {
    validateEmail (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      console.log('emailRegex.test(email)', emailRegex.test(email))
      return emailRegex.test(email)
    },
    async checkTypeEvenEmp (shopId, status, bookNo) {
      try {
        this.shopId = shopId
        if (this.shopId === this.shopNameData.englishMunmunCoppyTest || this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
          if (status !== 'Add') {
            console.log('-----------------------------IF------------------------------')
            this.evenStatus = status
            this.bookNo = bookNo
            await this.getShop()
            if (this.access_token === null || this.access_token === '') {
              await this.getBooking(this.bookNo)
              await this.getBookingData(this.bookNo)
              await this.getFlow(this.bookingItem[0].flowId)
              if (this.statusGoogleCalendarEmp === 'True') {
                await this.getEmp(this.bookingItem[0].bookingEmpFlow)
              }
              if (this.evenStatus === 'Add') {
                if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
                  await this.buliDataEmpCreateLog('Add')
                }
              }
            } else {
              await this.getBooking(this.bookNo)
              await this.getBookingData(this.bookNo)
              await this.getFlow(this.bookingItem[0].flowId)
              if (this.statusGoogleCalendarEmp === 'True') {
                await this.getEmp(this.bookingItem[0].bookingEmpFlow)
              }
              if (this.evenStatus === 'Add') {
                let allItem = await this.buliDataEmp('Add')
                await this.createEvent(allItem)
                if (shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
                  this.sentEmailEmp(bookNo)
                  this.sentSMS(bookNo)
                }
              } else if (this.evenStatus === 'Edit') {
                let allItem = await this.buliDataEmp('Edit')
                await this.updateEvent(allItem)
              } else if (this.evenStatus === 'Delete') {
                await this.deleteEvent()
                //   let allItem = await this.buliDataEmp('Delete')
              }
            }
          }
        } else {
          console.log('-----------------------------ELSE------------------------------')
          this.evenStatus = status
          this.bookNo = bookNo
          await this.getShop()
          if (this.access_token === null || this.access_token === '') {
            await this.getBooking(this.bookNo)
            await this.getBookingData(this.bookNo)
            await this.getFlow(this.bookingItem[0].flowId)
            if (this.statusGoogleCalendarEmp === 'True') {
              await this.getEmp(this.bookingItem[0].bookingEmpFlow)
            }
            if (this.evenStatus === 'Add') {
              if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
                await this.buliDataEmpCreateLog('Add')
              }
            }
          } else {
            await this.getBooking(this.bookNo)
            await this.getBookingData(this.bookNo)
            await this.getFlow(this.bookingItem[0].flowId)
            if (this.statusGoogleCalendarEmp === 'True') {
              await this.getEmp(this.bookingItem[0].bookingEmpFlow)
            }
            if (this.evenStatus === 'Add') {
              await this.buliDataEmpCreateLog('Add')
              let allItem = await this.buliDataEmp('Add')
              await this.createEvent(allItem)
              if (shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
                this.sentEmailEmp(bookNo)
                this.sentSMS(bookNo)
              }
            } else if (this.evenStatus === 'Edit') {
              let allItem = await this.buliDataEmp('Edit')
              await this.updateEvent(allItem)
            } else if (this.evenStatus === 'Delete') {
              await this.deleteEvent()
            //   let allItem = await this.buliDataEmp('Delete')
            }
          }
        }
      } catch (error) {
        console.log('error---------->>>>>', error)
      }
    },
    async buliDataEmp (status) {
      let item = {}
      item.access_token = this.access_token
      item.refreshToken = this.refreshToken
      item.bookNo = this.bookingItem[0].bookNo
      item.Summmary = this.bookingItem[0].flowName + ' - ' + this.bookingData.filter((a) => a.fieldName === 'ชื่อ')[0].fieldValue
      let Description = ''
      if (this.bookingItem[0].masBranchName !== null || this.bookingItem[0].masBranchName !== '') {
        Description += 'สาขา :' + this.bookingItem[0].masBranchName
        Description += '\n'
      }
      this.bookingData.forEach((a) => {
        Description += a.fieldName + ' : ' + (a.fieldValue || ' ')
        Description += '\n'
      })
      if (this.shopId) {
        item.shopId = this.shopId
      }
      if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        Description += 'ชื่อครู :' + this.bookingItem[0].bookingEmpFlowName
      } else if (this.shopId === 'U0774cc75554f5f80bf2fb88888c2eec3') {
        Description += 'ชื่อ Mentor :' + this.bookingItem[0].bookingEmpFlowName
      } else {
        Description += 'ชื่อช่าง :' + this.bookingItem[0].bookingEmpFlowName
      }
      if (this.shopId === 'U93c42b54e45cfe584473c03e35746955' || this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        let setUpTimes = await this.setUpTime(this.bookingItem[0].dueDateDay, this.bookingItem[0].timeDue, 60)
        item.StartDate = setUpTimes.startDate
        item.EndDate = setUpTimes.endDate
      } else {
        //    แปลงเวลานัดหมาย
        const timezone = 'Asia/Bangkok'
        const dateSelectNew = moment.tz(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`, 'YYYY-MM-DD HH:mm', timezone).format()
        // const dateSelect = moment(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`).format('YYYY-MM-DD HH:mm')
        item.StartDate = dateSelectNew
        item.EndDate = await this.setTimeEmp(dateSelectNew, this.bookingItem)
        if (item.StartDate >= item.EndDate) {
          // send noti item.StartDate  item.EndDate
          // let test = dateSelect.add(60, 'minutes')
          // item.EndDate = moment.tz(test, 'YYYY-MM-DD HH:mm', timezone).format()
          let dtInput = moment(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`).format('YYYY-MM-DD HH:mm')
          const dt = moment.tz(dtInput, 'YYYY-MM-DD HH:mm', timezone)
          const EndDateTime = dt.clone().add(60, 'minutes').format('YYYY-MM-DD HH:mm')
          item.EndDate = moment.tz(`${EndDateTime}`, 'YYYY-MM-DD HH:mm', timezone).format()
        }
      }
      if (this.shopId === 'U93c42b54e45cfe584473c03e35746955' || this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        try {
          const startDate = moment(item.StartDate).utcOffset('+07:00').locale('en')
          const endDate = moment(item.EndDate).utcOffset('+07:00').locale('en')

          // แปลงวันที่เป็นรูปแบบที่ต้องการ
          const formattedStart = startDate.format('DD MMM YYYY HH:mm')
          const formattedEnd = endDate.format('HH:mm')
          Description += '\n'
          Description += `${formattedStart} - ${formattedEnd} เวลาประเทศไทย (Thailand Time)`
        } catch (error) {
          console.log('error------->>>>>>>>', error)
        }
      }
      item.Description = Description
      await this.getSysUser()
      item.attendees = this.attendeesEmail
      if (this.statusGoogleCalendarEmp === 'True') {
        if (status === 'Add') {
          try {
            if (this.validateEmail(this.empItem[0].empEmail)) {
              let obj = {'email': this.empItem[0].empEmail}
              item.attendees.push(obj)
            }
          } catch (error) {
            console.log(error)
          }
        } else if (status === 'Edit') {
          try {
            if (this.validateEmail(this.empItem[0].empEmail)) {
              let obj = {'email': this.empItem[0].empEmail}
              item.attendees.push(obj)
            }
          } catch (error) {
            console.log(error)
          }
        }
        if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === 'U0774cc75554f5f80bf2fb88888c2eec3' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
          try {
            if (this.empItem[0].refreshTokenGoogleCalendar) {
              let data = await this.getRefreshTotokenEmp(this.empItem[0].refreshTokenGoogleCalendar)
              if (data) {
                item.access_token = data
                item.refreshToken = this.empItem[0].refreshTokenGoogleCalendar
                if (this.contactEmail) {
                  let obj = {'email': this.contactEmail}
                  item.attendees.push(obj)
                }
              }
            }
          } catch (error) {
            item.access_token = this.access_token
          }
        }
      }
      if (this.flowItem[0].GoogleCalendarMeet === 'True') {
        item.requestId = this.bookingItem[0].bookNo
        if (this.bookingItem[0].bookingDataCustomerEmail !== null && this.bookingItem[0].bookingDataCustomerEmail !== '') {
          let obj = {'email': this.bookingItem[0].bookingDataCustomerEmail}
          item.attendees.push(obj)
        }
      }
      if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        try {
          this.addLogWait(item)
        } catch (error) {
          console.log('error', error)
        }
      }
      return item
    },
    async buliDataEmpCreateLog (status) {
      let item = {}
      item.access_token = this.access_token
      item.refreshToken = this.refreshToken
      item.bookNo = this.bookingItem[0].bookNo
      item.Summmary = this.bookingItem[0].flowName + ' - ' + this.bookingData.filter((a) => a.fieldName === 'ชื่อ')[0].fieldValue
      let Description = ''
      if (this.bookingItem[0].masBranchName !== null || this.bookingItem[0].masBranchName !== '') {
        Description += 'สาขา :' + this.bookingItem[0].masBranchName
        Description += '\n'
      }
      this.bookingData.forEach((a) => {
        Description += a.fieldName + ' : ' + (a.fieldValue || ' ')
        Description += '\n'
      })
      if (this.shopId) {
        item.shopId = this.shopId
      }
      if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        Description += 'ชื่อครู :' + this.bookingItem[0].bookingEmpFlowName
      } else if (this.shopId === 'U0774cc75554f5f80bf2fb88888c2eec3') {
        Description += 'ชื่อ Mentor :' + this.bookingItem[0].bookingEmpFlowName
      } else {
        Description += 'ชื่อช่าง :' + this.bookingItem[0].bookingEmpFlowName
      }
      if (this.shopId === 'U93c42b54e45cfe584473c03e35746955' || this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        let setUpTimes = await this.setUpTime(this.bookingItem[0].dueDateDay, this.bookingItem[0].timeDue, 60)
        item.StartDate = setUpTimes.startDate
        item.EndDate = setUpTimes.endDate
      } else {
        //    แปลงเวลานัดหมาย
        const timezone = 'Asia/Bangkok'
        const dateSelectNew = moment.tz(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`, 'YYYY-MM-DD HH:mm', timezone).format()
        // const dateSelect = moment(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`).format('YYYY-MM-DD HH:mm')
        item.StartDate = dateSelectNew
        item.EndDate = await this.setTimeEmp(dateSelectNew, this.bookingItem)
        if (item.StartDate >= item.EndDate) {
          // send noti item.StartDate  item.EndDate
          // let test = dateSelect.add(60, 'minutes')
          // item.EndDate = moment.tz(test, 'YYYY-MM-DD HH:mm', timezone).format()
          let dtInput = moment(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`).format('YYYY-MM-DD HH:mm')
          const dt = moment.tz(dtInput, 'YYYY-MM-DD HH:mm', timezone)
          const EndDateTime = dt.clone().add(60, 'minutes').format('YYYY-MM-DD HH:mm')
          item.EndDate = moment.tz(`${EndDateTime}`, 'YYYY-MM-DD HH:mm', timezone).format()
        }
      }
      if (this.shopId === 'U93c42b54e45cfe584473c03e35746955' || this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
        try {
          const startDate = moment(item.StartDate).utcOffset('+07:00').locale('en')
          const endDate = moment(item.EndDate).utcOffset('+07:00').locale('en')

          // แปลงวันที่เป็นรูปแบบที่ต้องการ
          const formattedStart = startDate.format('DD MMM YYYY HH:mm')
          const formattedEnd = endDate.format('HH:mm')
          Description += '\n'
          Description += `${formattedStart} - ${formattedEnd} เวลาประเทศไทย (Thailand Time)`
        } catch (error) {
          console.log('error------->>>>>>>>', error)
        }
      }
      item.Description = Description
      await this.getSysUser()
      item.attendees = this.attendeesEmail
      if (this.statusGoogleCalendarEmp === 'True') {
        if (status === 'Add') {
          try {
            if (this.validateEmail(this.empItem[0].empEmail)) {
              let obj = {'email': this.empItem[0].empEmail}
              item.attendees.push(obj)
            }
          } catch (error) {
            console.log(error)
          }
        } else if (status === 'Edit') {
          try {
            if (this.validateEmail(this.empItem[0].empEmail)) {
              let obj = {'email': this.empItem[0].empEmail}
              item.attendees.push(obj)
            }
          } catch (error) {
            console.log(error)
          }
        }
        if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === 'U0774cc75554f5f80bf2fb88888c2eec3' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
          try {
            if (this.empItem[0].refreshTokenGoogleCalendar) {
              item.refreshToken = this.empItem[0].refreshTokenGoogleCalendar
              if (this.contactEmail) {
                let obj = {'email': this.contactEmail}
                item.attendees.push(obj)
              }
            }
          } catch (error) {
            item.access_token = ''
          }
        }
      }
      if (this.flowItem[0].GoogleCalendarMeet === 'True') {
        item.requestId = this.bookingItem[0].bookNo
        if (this.bookingItem[0].bookingDataCustomerEmail !== null && this.bookingItem[0].bookingDataCustomerEmail !== '') {
          let obj = {'email': this.bookingItem[0].bookingDataCustomerEmail}
          item.attendees.push(obj)
        }
      }
      try {
        this.addLogWait(item)
      } catch (error) {
        console.log('error', error)
      }
    },
    async setUpTime (date, time, countminutes) {
      // Input variables
      // let startDay = '2024-11-21';
      // let startTime = '23:30';
      let startDay = date
      let startTime = time
      // Split the date into components
      let [year, month, day] = startDay.split('-').map(Number)

      // Split the time into hours and minutes
      let [hours, minutes] = startTime.split(':').map(Number)

      // Add 60 minutes
      minutes += countminutes
      hours += Math.floor(minutes / 60) // Add extra hours if minutes exceed 59
      minutes = minutes % 60 // Keep minutes within 0-59 range

      // Adjust for hour overflow
      if (hours >= 24) {
        hours = hours % 24 // Keep hours within 0-23 range
        day += 1 // Increment day
      }

      // Handle month overflow (only approximate for simplicity, not accounting for leap years)
      let daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
      if (day > daysInMonth[month - 1]) {
        day = 1
        month += 1 // Increment month
        if (month > 12) {
          month = 1 // Reset month to January
          year += 1 // Increment year
        }
      }

      // Format the components to ensure two digits
      let formattedMonth = month.toString().padStart(2, '0')
      let formattedDay = day.toString().padStart(2, '0')
      let formattedHours = hours.toString().padStart(2, '0')
      let formattedMinutes = minutes.toString().padStart(2, '0')

      // Construct the startDate and endDate
      let startDate = `${startDay}T${startTime}:00+07:00`
      let endDay = `${year}-${formattedMonth}-${formattedDay}`
      let endTime = `${formattedHours}:${formattedMinutes}`
      let endDate = `${endDay}T${endTime}:00+07:00`

      console.log('startDate:', startDate)
      console.log('endDate:', endDate)
      return {
        'startDate': startDate,
        'endDate': endDate
      }
    },
    async checkTypeEven (shopId, status, bookNo) {
      this.shopId = shopId
      this.evenStatus = status
      //   this.evenStatus = 'Add'
      this.bookNo = bookNo
      //   this.bookNo = 'BK143157651684727414315'
      await this.getShop()
      if (this.access_token === null || this.access_token === '') {
        // await this.handleClickLogin(status, bookNo)
      } else {
        await this.getBooking(this.bookNo)
        await this.getBookingData(this.bookNo)
        await this.getFlow(this.bookingItem[0].flowId)
        // if (this.statusGoogleCalendarEmp === 'True') {
        //   await this.getEmp(this.bookingItem[0].bookingEmpFlow)
        // }
        if (this.evenStatus === 'Add') {
          await this.buliDataCreateLog('Add')
          let allItem = await this.buliData('Add')
          console.log('--------------------Add-------------------')
          await this.createEvent(allItem)
        } else if (this.evenStatus === 'Edit') {
          let allItem = await this.buliData('Edit')
          console.log('Edit!!')
          await this.updateEvent(allItem)
        } else if (this.evenStatus === 'Delete') {
          await this.deleteEvent()
          //   let allItem = await this.buliDataEmp('Delete')
        }
      }
    },
    async buliData (status) {
      let item = {}
      item.access_token = this.access_token
      item.refreshToken = this.refreshToken
      item.bookNo = this.bookingItem[0].bookNo
      item.Summmary = this.bookingItem[0].flowName + ' - ' + this.bookingData.filter((a) => a.fieldName === 'ชื่อ')[0].fieldValue
      let Description = ''
      if (this.bookingItem[0].masBranchName !== null || this.bookingItem[0].masBranchName !== '') {
        Description += 'สาขา :' + this.bookingItem[0].masBranchName
        Description += '\n'
      }
      this.bookingData.forEach((a) => {
        Description += a.fieldName + ' : ' + a.fieldValue
        Description += '\n'
      })
      //    แปลงเวลานัดหมาย
      item.Description = Description
      if (this.shopId) {
        item.shopId = this.shopId
      }
      const timezone = 'Asia/Bangkok'
      const dateSelect = moment.tz(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`, 'YYYY-MM-DD HH:mm', timezone).format()
      item.StartDate = dateSelect
      item.EndDate = await this.setTimeFlow(dateSelect, this.bookingItem[0].flowId)
      await this.getSysUser()
      console.log('this.attendeesEmail', this.attendeesEmail)
      item.attendees = this.attendeesEmail
      if (this.flowItem[0].GoogleCalendarMeet === 'True') {
        item.requestId = this.bookingItem[0].bookNo
        if (this.bookingItem[0].bookingDataCustomerEmail !== null && this.bookingItem[0].bookingDataCustomerEmail !== '') {
          let obj = {'email': this.bookingItem[0].bookingDataCustomerEmail}
          item.attendees.push(obj)
        }
      }
      return item
    },
    async buliDataCreateLog (status) {
      let item = {}
      item.access_token = this.access_token
      item.refreshToken = this.refreshToken
      item.bookNo = this.bookingItem[0].bookNo
      item.Summmary = this.bookingItem[0].flowName + ' - ' + this.bookingData.filter((a) => a.fieldName === 'ชื่อ')[0].fieldValue
      let Description = ''
      if (this.bookingItem[0].masBranchName !== null || this.bookingItem[0].masBranchName !== '') {
        Description += 'สาขา :' + this.bookingItem[0].masBranchName
        Description += '\n'
      }
      this.bookingData.forEach((a) => {
        Description += a.fieldName + ' : ' + (a.fieldValue || ' ')
        Description += '\n'
      })
      //    แปลงเวลานัดหมาย
      item.Description = Description
      if (this.shopId) {
        item.shopId = this.shopId
      }
      const timezone = 'Asia/Bangkok'
      const dateSelect = moment.tz(`${this.bookingItem[0].dueDateDay} ${this.bookingItem[0].timeDue}`, 'YYYY-MM-DD HH:mm', timezone).format()
      item.StartDate = dateSelect
      item.EndDate = await this.setTimeFlow(dateSelect, this.bookingItem[0].flowId)
      await this.getSysUser()
      console.log('this.attendeesEmail', this.attendeesEmail)
      item.attendees = this.attendeesEmail
      if (this.flowItem[0].GoogleCalendarMeet === 'True') {
        item.requestId = this.bookingItem[0].bookNo
        if (this.bookingItem[0].bookingDataCustomerEmail !== null && this.bookingItem[0].bookingDataCustomerEmail !== '') {
          let obj = {'email': this.bookingItem[0].bookingDataCustomerEmail}
          item.attendees.push(obj)
        }
      }
      try {
        this.addLogWait(item)
      } catch (error) {
        console.log('error', error)
      }
    },
    async addLogWait (item) {
      console.log('addLogWait---11111---', item)
      await axios.post(this.DNS_IP + '/GoogleCalendar/addWait', item)
        .then(response => {})
        .catch(error => { console.log(error) })
    },
    async sentEmailEmp (bookNo) {
      let dt = {
        'bookNo': bookNo
      }
      await axios.post(this.DNS_IP + '/email_booking/confirmEnglistMunMun', dt)
        .then(response => {})
        .catch(error => { console.log(error) })
    },
    async sentSMS (bookNo) {
      let dt = {
        'bookNo': bookNo
      }
      await axios.post(this.DNS_IP + '/sms_booking/confirmEnglistMunMun', dt)
        .then(response => {})
        .catch(error => { console.log(error) })
    },
    async getBooking () {
      await axios.get(this.DNS_IP + '/booking_view/get?bookNo=' + this.bookNo).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          this.bookingItem = rs
        }
      })
    },
    async getBookingData () {
      await axios.get(this.DNS_IP + '/BookingData/get?bookNo=' + this.bookNo).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          this.bookingData = rs
        }
      })
    },
    async getFlow (flowId) {
      await axios.get(this.DNS_IP + '/flow/get?flowId=' + flowId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          this.flowItem = rs
        }
      })
    },
    async getEmp (empId) {
      await axios.get(this.DNS_IP + '/empSelect/get?empId=' + empId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          this.empItem = rs
        }
      })
    },
    async setTimeEmp (dateSelect, bookingData) {
      let date = moment(dateSelect).format('YYYY-MM-DD')
      let time = moment(dateSelect).format('HH:mm')
      let timeSlot = bookingData[0].timeSlotCustomer || 1
      let countTime = 60
      try {
        let setTime = await this.getTimeEmp(date, bookingData[0].bookingEmpFlow)
        // console.log(setTime)
        if (setTime.length === 0 || setTime.length === 1) {
          countTime = 60
        } else {
          let firtIndex = setTime.findIndex((item) => item.value === time)
          let filterTime = setTime.filter((item, index) => index >= firtIndex && index <= ((timeSlot + firtIndex)))
          if (timeSlot !== filterTime.length) {
            let previousTime = moment(setTime[0].value, 'HH:mm')
            let currentTime = moment(setTime[1].value, 'HH:mm')
            const diffMinutes = currentTime.diff(previousTime, 'minutes')
            countTime = (diffMinutes * timeSlot) === 0 ? 60 : (diffMinutes * timeSlot)
            console.log('diffMinutes', diffMinutes)
          } else {
            let previousTime = moment(filterTime[0].value, 'HH:mm')
            let currentTime = moment(filterTime[filterTime.length - 1].value, 'HH:mm')
            console.log('previousTime', previousTime)
            console.log('currentTime', currentTime)
            const diffMinutes = currentTime.diff(previousTime, 'minutes')
            countTime = diffMinutes === 0 ? 60 : diffMinutes
            // console.log('diffMinutesElse', diffMinutes)
          }
        }
      } catch (error) {
        console.log(bookingData[0].bookNo + '\nError fetching flow data:', error)
        countTime = 60
      }
      const timezone = 'Asia/Bangkok'
      let dtInput = moment(dateSelect).format('YYYY-MM-DD HH:mm')
      const dt = moment.tz(dtInput, 'YYYY-MM-DD HH:mm', timezone)
      const EndDateTime = dt.clone().add(countTime, 'minutes').format('YYYY-MM-DD HH:mm')
      let dataReturn = moment.tz(`${EndDateTime}`, 'YYYY-MM-DD HH:mm', timezone).format()
      // console.log('dataReturn', dataReturn)
      return dataReturn
    },
    async getTimeEmp (dateSelect, empId) {
      try {
        const response = await axios.get(this.DNS_IP + '/empSelect/get?empId=' + empId)
        const rs = response.data
        if (rs.length > 0) {
          let setTime = []
          if (rs[0].setTimebyday === 'True') {
            let timeData = JSON.parse(rs[0].setTime)
            let timeJson = timeData.find((items) => items.value === new Date(dateSelect).getDay()) || {}
            // console.log('timeJson', timeJson)
            setTime = timeJson.setTime || []
          } else {
            setTime = JSON.parse(rs[0].setTime) || []
          }
          return setTime
        }
      } catch (error) {
        console.error('Error fetching flow data:', error)
        return []
      }
    },
    async setTimeFlow (dateSelect, flowId) {
      const timezone = 'Asia/Bangkok'
      let dtInput = moment(dateSelect).format('YYYY-MM-DD HH:mm')
      const dt = moment.tz(dtInput, 'YYYY-MM-DD HH:mm', timezone)
      // console.log('dt', dt)
      let countTime = 60
      try {
        const response = await axios.get(this.DNS_IP + '/flow/get?flowId=' + flowId)
        const rs = response.data
        if (rs.length > 0) {
          console.log('FLOW-------!!!!!', rs)
          countTime = rs[0].OnsiteEndTime === 0 ? 60 : rs[0].OnsiteEndTime
          const EndDateTime = dt.clone().add(countTime, 'minutes').format('YYYY-MM-DD HH:mm')
          let dataReturn = moment.tz(`${EndDateTime}`, 'YYYY-MM-DD HH:mm', timezone).format()
          // คืนค่า countTime หรือ EndDateTime ตามที่ต้องการ
          return dataReturn // หรือ return EndDateTime ตามที่คุณต้องการ
        }
      } catch (error) {
        console.error('Error fetching flow data:', error)
        const EndDateTime = dt.clone().add(countTime, 'minutes').format('YYYY-MM-DD HH:mm')
        let dataReturn = moment.tz(`${EndDateTime}`, 'YYYY-MM-DD HH:mm', timezone).format()
        return dataReturn
      }
    },
    // async checkExpireDate (expireDate) {
    //   // const timestamp = 1684397395837
    //   // const expirationDate = moment.utc(timestamp)
    //   const currentDate = moment()
    //   // console.log('currentDate', currentDate)
    //   if (currentDate.isAfter(expireDate)) {
    //     console.log('รหัสหมดอายุแล้ว1')
    //     await this.handleClickLogin()
    //   } else {
    //     console.log('รหัสยังไม่หมดอายุ1')
    //   }
    // // },
    // ConvertToDateTime (expirydate) {
    //   const timestamp = expirydate
    //   const dateTime = moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    //   console.log(dateTime)
    //   return dateTime
    // },
    async UpdateRefreshToken (res) {
      console.log('res', res)
      const refreshToken = res.refresh_token
      const item = {
        refreshTokenGoogleCalendar: refreshToken
      }
      await axios
        .post(this.DNS_IP + '/sys_shop/edit/' + this.shopId, item)
        .then(async response => {
          console.log('response', response)
        })
        .catch((err) => { console.log('error', err) })
    },
    async handleClickLogin (status, bookNo) {
      this.$gAuth
        .getAuthCode()
        .then((authCode) => {
        // on success
          console.log('authCode', authCode)
          axios
            .post(this.webHookUrl + 'GoogleCalendar-createToken', {code: authCode})
          // .post('http://localhost:5002/be-linked-a7cdc/asia-southeast1/GoogleCalendar-createToken', {code: authCode})
            .then(async (response) => {
            // this.checkLogin = true
              console.log('token', response.data)
              await this.UpdateRefreshToken(response.data)
              await this.checkTypeEvenEmp(status, bookNo)
            }).catch((err) => {
              console.log('err', err)
            })
        })
        .catch((error) => {
          console.log('error login', error)
        // on fail do something
        })
    },
    async UpdateEventId_Booking (bookNo, googleCalendarEventId) {
      console.log('response.data.id', googleCalendarEventId)
      const dataitem = {
        'googleCalendarEventId': googleCalendarEventId
      }
      await axios
        .post(this.DNS_IP + '/Booking/edit/' + bookNo, dataitem)
        .then(async response => {
          console.log('response!@!@!@!@', response)
        })
        .catch((err) => { console.log('error', err) })
    },
    async createEvent (item, bookNo) {
      // try {
      //   await axios
      //     .post(this.webHookUrl + 'GoogleCalendar-createEvent', item)
      //     .then(async (response) => {
      //       console.log('createEvent', response.data)
      //       console.log('response.data.id', response.data.data.id)
      //       await this.UpdateEventId_Booking(this.bookNo, response.data.data.id)
      //     })
      // } catch (error) {
      //   console.log('error', error)
      // }
      try {
        await axios
          .post(this.DNS_IP + '/GoogleCalendar/create', item)
          .then(async response => { console.log(response) })
      } catch (error) {
        console.log('error', error)
      }
    },
    getEvent () {
      let dt = {
        access_token: this.access_token,
        eventId: this.eventId
      }
      axios
        .post(this.webHookUrl + 'GoogleCalendar-getEvent', dt)
        .then(async (response) => {
          console.log('getEvent', response.data)
          if (response.data.status === 200) {
            this.Summmary = response.data.data.summary
            this.Description = response.data.data.description
            this.Location = response.data.data.location
            this.StartDate = this.momenDate_1(response.data.data.start.dateTime)
            this.EndDate = this.momenDate_1(response.data.data.end.dateTime)
          } else {
            this.Summmary = ''
            this.Description = ''
            this.Location = ''
            this.StartDate = ''
            this.EndDate = ''
          }
        })
    },
    async getEventCheck () {
      let itemGet = {
        access_token: this.access_token,
        eventId: this.bookingItem[0].googleCalendarEventId
      }
      let rsData = []
      await axios
        .post(this.webHookUrl + 'GoogleCalendar-getEvent', itemGet)
        .then(async (response) => {
          console.log('getEvent', response.data)
          if (response.data.status === 200) {
            let rs = response.data.data
            if (rs.attendees) {
              let empEmail = rs.attendees.filter((a) => a.email !== rs.creator.email)
              rsData = empEmail
            } else {
              rsData = []
            }
          } else {
            rsData = []
          }
        })
      return rsData
    },
    async updateEvent (item) {
      let itemUpdate = item
      itemUpdate.eventId = this.bookingItem[0].googleCalendarEventId
      if (this.bookingItem[0].googleCalendarEventId !== null) {
        // try {
        //   await axios
        //     .post(this.webHookUrl + 'GoogleCalendar-updateEvent', itemUpdate)
        //     .then(async (response) => {
        //       console.log('updateEvent11', response.data)
        //     }).catch((err) => {
        //       console.log('error', err)
        //     })
        // } catch (error) {
        //   console.log('error', error)
        // }
        try {
          await axios
            .post(this.DNS_IP + '/GoogleCalendar/update', itemUpdate)
            .then(async response => { console.log(response) })
        } catch (error) {
          console.log('error', error)
        }
      }
    },
    async deleteEvent () {
      let dt = {
        refreshToken: this.refreshToken,
        access_token: this.access_token,
        eventId: this.bookingItem[0].googleCalendarEventId,
        bookNo: this.bookNo
      }
      // await axios
      //   .post(this.webHookUrl + 'GoogleCalendar-deleteEvent', dt)
      //   .then(async (response) => {
      //     console.log('deleteEvent', response.data)
      //   })
      if (this.bookingItem[0].googleCalendarEventId !== null) {
        try {
          await axios
            .post(this.DNS_IP + '/GoogleCalendar/delete', dt)
            .then(async response => { console.log(response) })
        } catch (error) {
          console.log('error', error)
        }
      }
    },
    async getShop () {
      await axios.get(this.DNS_IP + '/sys_shop/get?shopId=' + this.shopId).then(async (response) => {
        let rs = response.data
        if (rs.length > 0) {
          this.contactEmail = rs[0].contactEmail
          if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef' || this.shopId === 'U0774cc75554f5f80bf2fb88888c2eec3' || this.shopId === this.shopNameData.englishMunmunCoppyTest) {
            if (rs[0].refreshTokenGoogleCalendar) {
              await this.getRefreshTotoken(rs[0].refreshTokenGoogleCalendar)
            } else {
              this.access_token = ''
            }
          } else {
            await this.getAccess_token()
          }
          // this.access_token = rs[0].access_tokenGoogleCalendar
          // saichongot123@gmail.com 1//0g96maaiJcjKnCgYIARAAGBASNwF-L9IrvFA4GuAGtvfLf5ZfmSDxoXxBeym4BpxaJjVoc5SrB176u4FsYYoCCWa7rrwdAh-CZkA
          // this.access_token = '1//0gYwyLYeD179cCgYIARAAGBASNwF-L9Ir4eWR6-pPbjgYzJYPqm74y0-JiXqw5EmCbKduRf5VF0c1BIgD37qsWdtqt7bENC5uBss'
          this.statusGoogleCalendarEmp = rs[0].statusGoogleCalendarEmp
        }
      })
    },
    async getAccess_token () {
      await axios.get(this.DNS_IP + '/GoogleCalendarRefreshToken/get').then(response => {
        let rs = response.data
        if (rs.length > 0) {
          console.log('GoogleCalendarRefreshToken', rs)
          this.access_token = rs[0].access_token
          this.refreshToken = rs[0].refreshToken
        }
      })
    },
    async getRefreshTotokenEmp (refreshToken) {
      let dt = {
        refreshToken: refreshToken
      }
      let token = null
      await axios
        .post(this.webHookUrl + 'GoogleCalendar-GetToken', dt)
        .then(async (response) => {
          console.log(response)
          if (response.data.access_token) {
            token = response.data.access_token
          }
        })
        .catch((error) => {
          console.log(error)
        })
      console.log('token', token)
      return token
    },
    async getRefreshTotoken (refreshToken) {
      let dt = {
        refreshToken: refreshToken
      }
      await axios
        .post(this.webHookUrl + 'GoogleCalendar-GetToken', dt)
        .then(async (response) => {
          console.log(response)
          if (response.data.access_token) {
            this.access_token = response.data.access_token
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getSysUser () {
      await axios.get(this.DNS_IP + '/system_user/get?shopId=' + this.shopId + '&USER_ROLE=admin').then(response => {
        let rs = response.data
        if (rs.length > 0) {
          console.log('system_user', rs)
          rs.forEach((item) => {
            let obj = {
              'email': item.userName
            }
            this.attendeesEmail.push(obj)
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Core/GoogleCalendarCmp.vue